export default "__VITE_ASSET__BUHEf6YZ__"